export function isConditionsGroup(condition) {
    return 'operator' in condition;
}
export function isConditionSimple(condition) {
    return !isConditionsGroup(condition);
}
export function isMultiOperator(operator) {
    return operator === 'in' || operator === 'notin';
}
export function isValueLessOperator(operator) {
    return operator === 'notset' || operator === 'any';
}
export function isDaysAgoOperator(operator) {
    return operator.startsWith('daysago');
}
export function isBetweenOperator(operator) {
    return operator === 'between' || operator === 'daysago between';
}
